<template>
  <div>
    <jd-form
      ref="orderDetailRef"
      class="mb16"
      :form-info="inputOrderDetail"
      @search="searchOrderDetail"
    />
    <jd-button
          type="text"
          style="float: right; margin-top: 16px;margin-bottom: 10px;"
          @click="exportFn"
          v-permission="'hide:checkOrder:export'" 
          >导出</jd-button
    >
    <orderDetailOverview ref="orderDetailOverviewRef" :rowData="rowData"></orderDetailOverview>
    <div class="new-table-box">
      <jd-table
        :loading="loading"
        :tableData="orderDetailData"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        style="width: 100%"
        :pageInfo="{
          pageNum: orderDetailPage.current,
          pageSize: orderDetailPage.size,
          total: orderDetailPage.total,
        }"
        @handlePage="
          (val) => {
            (this.orderDetailPage.current = val.pageNum),
              (this.orderDetailPage.size = val.pageSize);
            searchOrderDetail();
          }
        "
      >
        <el-table-column prop="orderId" label="订单编号"> </el-table-column>
        <el-table-column prop="rootId" label="父订单号"> </el-table-column>
        <el-table-column :prop="chaosParams" :label="`${grayText}`">
        </el-table-column>
        <el-table-column prop="memberNick" label="用户昵称">
        </el-table-column>
        <el-table-column prop="sellerLinkName" label="投放渠道"></el-table-column>
        <el-table-column prop="orderVenderName" label="下单店铺"></el-table-column>
        <el-table-column prop="orderStartTime" label="下单时间">
        </el-table-column>
        <el-table-column prop="paymentConfirmTime" label="付款时间">
        </el-table-column>
        <el-table-column prop="orderPayment" label="订单金额"></el-table-column>
        <el-table-column prop="itemNum" label="商品件数"> </el-table-column>
           <el-table-column prop="skuNameList" label="商品名称" min-width="170">
              <template slot="header">
                <span>商品名称</span>
                <el-button 
                  type="text" 
                  class="header-expand-btn"
                  @click.stop="toggleGoodsNameExpand"
                >
                  【展开】
                </el-button>
              </template>
              <template slot-scope="scope">
                <div 
                  class="goods-name-text" 
                  :class="{ 'ellipsis-single': !goodsNameColumnExpanded, 'ellipsis-double': goodsNameColumnExpanded }"
                >
                  {{ scope.row.itemName ? (Array.isArray(scope.row.itemName) ? scope.row.skuNameList.join('，') : scope.row.itemName) : '' }}
                </div>
              </template>
         </el-table-column>
         <el-table-column prop="measureUnitCount" label="自定义计量单位数量" width="150"> 
           <template #default="{row}">
            {{ row.measureUnitCount || "" }}{{ row.measureUnitName || "" }}
           </template>
        </el-table-column>
        <!-- <el-table-column prop="orderCount" label="订单笔数"> </el-table-column> -->
        <el-table-column prop="orderStateRemark" label="订单状态">
          <template #default="{row}">
           <jd-status :status="getStatus(row.orderStateRemark,row.orderState)">{{ row.orderStateRemark }}</jd-status> 
          </template>
        </el-table-column>
      </jd-table>
    </div>
  </div>
</template>

<script>
import { orderDetailPage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import orderDetailOverview from "./orderDetailOverview.vue";
export default {
  props: {
    rowData: {
      // 活动数据
      type: Object,
      default: () => {},
    },
    sellerLinkList: {
      type: Array,
      default: () => []
    },
    shopList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    orderDetailOverview,
  },
  data() {
    return {
      goodsNameColumnExpanded: false,
      orderDetailPageCode:{},
      inputOrderDetail: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户Pin,精确查询",
        },
        {
          label: "订单编号：",
          prop: "orderId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "父订单号：",
          prop: "rootId",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "订单状态：",
          prop: "orderState",
          value: "",
          type: "Select",
          options: [
            { label: "全部", value: "", defaultValue: [""] },
            { label: "未付款", value: "WAIT_PAYMENT" },
            { label: "等待出库", value: "WAIT_SELLER_STOCK_OUT" },
            { label: "等待确认收货", value: "WAIT_GOODS_RECEIVE_CONFIRM" },
            { label: "已完成", value: "FINISHED_L" },
            { label: "已取消", value: "TRADE_CANCELED" },
            { label: "退货", value: "LOCKED" },
            { label: "暂停", value: "PAUSE" },
          ],
          multiple: true,
        },
        {
          label: "下单时间：",
          prop: "dateRange",
          type: "DateRange",
          dateType: "datetime",
          // startTime: this.getDateStr(-30) + " 00:00:00",
          // endTime: this.getDateStr(0) + " 23:59:59",
          startTime: '',//进来默认时间但没传值，所以测试叫我去掉默认值
          endTime: '',
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "选择日期时间",
          endPlaceholder: "选择日期时间",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: []
        },
        {
          label: "下单店铺：",
          prop: "orderVenderId",
          type: "Select",
          value: "",
          options: []
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        }
      ],
      loading: false, // 加载
      orderDetailData: [], // 订单明细
      orderDetailPage: {
        // 订单明细分页
        current: 1, // 当前页
        size: 10, // 每页条数
        total: 0, // 总条数
      },
    };
  },
  computed: {
    searchGrayId() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin'
    },
    grayText() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin（加密）'
    },
    chaosParams() {
      return this.$store.getters.loginUserInfo.isGray ? 'chaosXid' : 'chaosPin'
    },
  },
  watch: {
    sellerLinkList: {
      handler(newVal, oldVal) {
        if(newVal.length) {
          const list = newVal.map((item)=>{
            return {
              label: item.sellerLinkName,
              value: item.id
            }
          })
          this.inputOrderDetail.some((item)=>{
            if(item.prop=='sellerLinkId') {
              item.options = list
            }
          })
        }
      },
      deep: true,
    },
    shopList: {
      handler(newVal, oldVal) {
        if(newVal.length) {
          const list = newVal.map((item)=>{
            return {
              label: item.shopTitle,
              value: item.venderId
            }
          })
          this.inputOrderDetail.some((item)=>{
            if(item.prop=='orderVenderId') {
              item.options = list
            }
          })
        }
      },
      deep: true,
    },
    searchGrayId: {
      handler(newVal, oldVal) {
        this.inputOrderDetail.forEach((item)=>{
          if(item.prop=='pin') {
            item.label = item.label.replace(/pin/ig, newVal)
            item.prop = newVal;
            item.placeholder = item.placeholder.replace(/pin/ig, newVal)
          }
        })
      },
      immediate: true,
    }
  },
  methods: {
    exportFn() {
     this.$emit('exportFn', this.orderDetailPageCode )
    },
    // 切换商品名称列展开/收起状态 - 直接修改点击按钮，永远不丢失事件
    toggleGoodsNameExpand(e) {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      // 切换状态变量，控制内容行展开/收起
      this.goodsNameColumnExpanded = !this.goodsNameColumnExpanded;
      // 直接修改当前点击的按钮文字，无需等待无需查找节点
      e.target.innerText = this.goodsNameColumnExpanded ? '【收起】' : '【展开】';
    },
    getStatus(tips,orderState){
      if(tips=='已完成' || orderState=='FINISHED_L'){
        return 0
      }else if(tips=='等待出库' || orderState=='WAIT_SELLER_STOCK_OUT' || tips == '等待确认收货' || orderState=='WAIT_GOODS_RECEIVE_CONFIRM'){
        return 1
      }else if(tips=='未付款' || orderState=='WAIT_PAYMENT'){
        return 2
      }else if(tips=='退货' || orderState=='LOCKED' || tips=='暂停' || orderState=='PAUSE'){
        return 3
      }else if(tips=='已取消' || orderState=='TRADE_CANCELED'){
        return 4
      }
    },
    // 订单明细搜索
    searchOrderDetail(val) {
      this.loading = true;
      const { size, current } = this.orderDetailPage;
      const query = {
        size,
        current,
        activityId: this.rowData.id,
      };
      if (val && val[this.searchGrayId]) {
        query[this.searchGrayId] = val[this.searchGrayId];
      }
      if (val && val.orderId) {
        query.orderId = val.orderId;
      }
      if (val && val.rootId) {
        query.rootId = val.rootId;
      }
      if (val && val.orderState && val.orderState.length) {
        // 不等于全部
        if (!val.orderState.some((item) => !item)) {
          query.orderState = val.orderState.join(",");
        }
      }
      if (val && val.startTime) {
        query.startTime = val.startTime;
      }
      if (val && val.endTime) {
        query.endTime = val.endTime;
      }
      if (val && val.sellerLinkId) { 
        query.sellerLinkId = val.sellerLinkId;
      }
      if (val && val.orderVenderId) {
        query.orderVenderId = val.orderVenderId;
      }
      if (val && val.memberNick) {
        query.memberNick = val.memberNick;
      }
      this.orderDetailPageCode = query
      console.log(query,'6656545611111111')
      this.$refs.orderDetailOverviewRef.getDataOverview(query);
      orderDetailPage(query)
        .then((res) => {
          let { records = [], total = 0 } = res.data || {};
          this.loading = false;
          this.orderDetailData = records;
          this.orderDetailPage.total = Number(total);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 订单明细分页-数量
    handleSizeOrderDetail(size) {
      this.orderDetailPage.size = size;
      this.searchOrderDetail();
    },
    // 订单明细分页-页数
    handleCurrentOrderDetail(current) {
      this.orderDetailPage.current = current;
      this.searchOrderDetail();
    },
  },
};
</script>

<style lang="scss" scoped>
.goods-name-text.ellipsis-single {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
